import { render } from "./PsychologicalActivity.vue?vue&type=template&id=dda04104&scoped=true&ts=true"
import script from "./PsychologicalActivity.vue?vue&type=script&lang=ts"
export * from "./PsychologicalActivity.vue?vue&type=script&lang=ts"

import "./PsychologicalActivity.vue?vue&type=style&index=0&id=dda04104&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda04104"]])

export default __exports__